import React, { useState, useEffect } from 'react';
import { FaPen, FaSearch, FaUpload, FaThumbsDown, FaCheck,
    FaEllipsisV, FaTimes, FaSync, FaChevronDown, FaChevronRight, FaCalendarAlt, FaExpandAlt, FaCompressAlt, FaClock, FaPaperPlane, FaRegFileAlt } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import api from '../../services/api';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { moeda, ACEITE_RECIBO, erroSeNaoForPdf } from '../../util/util';
import { toast } from 'react-toastify';
import axios from 'axios';
import { FinAjuda, FinField, FinTextarea } from '../FinField';
import { rotaDetalheAdiantamento, cliqueEmControle, periodoEvento, destinatarioRecibo, posDoEvento } from '../../pages/Financeiro/Adiantamento/adiantamentoDetalhePolicy';
import { podeGerenciarDocAdiantamento, AVISO_SEM_PERMISSAO_DOC, temComprovanteAdiantamento } from './adiantamentoDocumentoPolicy';
import { DocumentosParcelaModal } from './DocumentosParcela';
import Data from '../Data';
import '../../css/financeiro-parcela-pagar.css';
import AdiantamentoClientePagou from './AdiantamentoClientePagou';

// Rafael (28/09, opção B): Alterar/Estornar seguem indisponíveis aqui; a ajuda aponta onde se renegocia.
const AJUDA_RENEGOCIACAO = 'Renegociação é feita pela equipe do evento em Orçamento › Solicitar Adiantamento › Adiantamentos. Aqui o Financeiro só informa o crédito (Informar Crédito → Creditado / Não Creditado).';

// Painel autocontido de Adiantamentos (entrada de caixa → Contas a Receber).
// Aprovado (Informar Crédito → Creditado OU recibo anexado), o adiantamento migra p/
// "Custo Previsto" (Contas a Pagar). Mas o item só SAI desta lista quando tiver AMBOS:
// recibo anexado E crédito confirmado (status_pagamento='creditado').
//
// CUIDADO com o rótulo: `dataAprovacaoDiretor` é setado pelos DOIS caminhos (o
// upload do recibo também seta). Logo ele significa "saiu para Contas Pendentes",
// NÃO "o cliente pagou". Quem responde por dinheiro recebido é
// `status_pagamento === 'creditado'` — sempre use ehCreditado() para isso.
export default function PainelAdiantamentos() {
    const history = useHistory();
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem('empresa');
    const perfil = localStorage.getItem('perfil');

    const [showActionsModal, setShowActionsModal] = useState(false);
    const [actionsModalData, setActionsModalData] = useState({ parcela: null, actions: [] });
    const [adiantamentos, setAdiantamentos] = useState([]);
    const [loadingAdiantamentos, setLoadingAdiantamentos] = useState(false);
    const [eventosAdiantAbertos, setEventosAdiantAbertos] = useState({});
    const [uploadingRecibo, setUploadingRecibo] = useState({}); // { [parcelaId]: bool }
    const [caixas, setCaixas] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [carregandoCaixas, setCarregandoCaixas] = useState(false);
    const [busca, setBusca] = useState('');
    // Filtro de cliente — mesmo padrão de "A Receber"/"Recebidas" (Rafael, 18/08).
    const [filtroCliente, setFiltroCliente] = useState('');
    // Item 13 (treinamento 07/10): prorrogar vencimento + aviso dos que venceram sem crédito.
    const [prorrogarModal, setProrrogarModal] = useState(null); // { parcela, data, motivo, salvando }
    const [soVencidosSemCredito, setSoVencidosSemCredito] = useState(false);
    // Modal "Informar Crédito" (Creditado / Não creditado)
    const [modalCredito, setModalCredito] = useState(null); // parcela | null
    const [modalCreditoSel, setModalCreditoSel] = useState(null); // 'creditado' | 'nao_creditado'
    const [modalCreditoObs, setModalCreditoObs] = useState('');
    const [modalCreditoData, setModalCreditoData] = useState(''); // QA 5.3.1: data em que o valor foi creditado
    const [modalCreditoCaixa, setModalCreditoCaixa] = useState(''); // conta/banco/cartão onde o valor caiu
    const [excluirModal, setExcluirModal] = useState(null); // row | null — modal padrão fin-pp de excluir pedido
    const [motivoExcluir, setMotivoExcluir] = useState('');
    const [excluindoAdt, setExcluindoAdt] = useState(false);
    const [salvandoCredito, setSalvandoCredito] = useState(false);

    const toggleEventoAdianto = (key, abertoAtual) => setEventosAdiantAbertos(prev => ({ ...prev, [key]: abertoAtual !== undefined ? !abertoAtual : !prev[key] }));

    // Recibo de adiantamento: a parcela serializada traz `arquivoreciboadiantamento`
    // como objeto Arquivo (relação carregada) ou como id string/número (coluna crua) ou null.
    // D-0118: modal Documentos (abrir, substituir e excluir recibo/comprovante).
    const [docsModal, setDocsModal] = useState(null); // parcela

    const temRecibo = (p) => {
        var r = p && p.arquivoreciboadiantamento;
        return !!(r && (typeof r === 'object' ? r.id : r));
    };

    // Crédito confirmado de verdade (dinheiro caiu) — sinal próprio, distinto do
    // recibo e do dataAprovacaoDiretor. Setado pelo aprovar() (Informar Crédito → Creditado).
    const ehCreditado = (p) => p && p.status_pagamento === 'creditado';

    const buscarAdiantamentos = () => {
        setLoadingAdiantamentos(true);
        api({
            method: 'get',
            action: '/financeiroParcela',
            token: token,
            params: { tipo: 2, adiantamento: 1 }
        }).then(response => {
            setAdiantamentos(response?.data?.data || []);
        }).catch(() => {
            toast.error('Erro ao buscar adiantamentos');
            setAdiantamentos([]);
        }).finally(() => {
            setLoadingAdiantamentos(false);
        });
    };

    const buscarCaixas = () => {
        setCarregandoCaixas(true);
        api({
            method: 'get',
            action: '/financeiroCaixa',
            token: token,
            params: { empresa: empresa }
        })
            .then(response => { setCaixas(response.data.data || []); })
            .catch(() => {})
            .finally(() => setCarregandoCaixas(false));
    };

    const podeAprovarAdiantamento = ['diretor', 'admin', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'].includes((perfil || '').trim().toLowerCase());

    // "Informar Crédito" = UM modal onde o Financeiro escolhe:
    //  • Creditado (cliente pagou) → adiantamento vai para "Aguardando NF" em Custos Previstos (aprovar).
    //  • Não creditado (valor não caiu) → marca status_pagamento; fica na lista p/ renegociação.
    const abrirInformarCredito = (parcela) => {
        setModalCreditoSel(null);
        setModalCreditoObs('');
        setModalCreditoData('');
        // Treinamento 07/10: o select de banco abria vazio quando a lista de
        // caixas ainda não tinha chegado (ou falhou no carregamento da tela).
        // Recarrega ao abrir e já sugere a última conta usada neste navegador.
        let ultimaCaixa = '';
        try { ultimaCaixa = localStorage.getItem('adiantamento.ultimaCaixaCredito') || ''; } catch (e) { ultimaCaixa = ''; }
        setModalCreditoCaixa(ultimaCaixa);
        buscarCaixas();
        setModalCredito(parcela);
    };
    const fecharInformarCredito = () => {
        setModalCredito(null);
        setModalCreditoSel(null);
        setModalCreditoObs('');
        setModalCreditoData('');
        setModalCreditoCaixa('');
    };
    const salvarInformarCredito = () => {
        if (!modalCreditoSel) { toast.warning('Selecione Creditado ou Não creditado.'); return; }
        const caixaCreditoValida = (caixas || []).some(c => String(c.id) === String(modalCreditoCaixa));
        if (modalCreditoSel === 'creditado' && !caixaCreditoValida) {
            toast.warning('Informe em qual conta/banco/cartão o adiantamento foi creditado.');
            return;
        }
        const parcela = modalCredito;
        if (!parcela) return;
        setSalvandoCredito(true);
        const req = modalCreditoSel === 'creditado'
            ? api({ method: 'post', action: '/financeiroParcela/aprovar', token: token, data: { parcelaIds: [parcela.id], comentarios: modalCreditoObs, data_credito: modalCreditoData || null, caixa: modalCreditoCaixa || null } })
            : api({ method: 'put', action: '/financeiroParcela/' + parcela.id + '/statusPagamento', token: token, data: { status: 'nao_creditado', observacao: modalCreditoObs } });
        req
            .then(() => {
                if (modalCreditoSel === 'creditado' && modalCreditoCaixa) {
                    try { localStorage.setItem('adiantamento.ultimaCaixaCredito', String(modalCreditoCaixa)); } catch (e) { /* sem storage */ }
                }
                toast.success(modalCreditoSel === 'creditado'
                    ? 'Valor creditado! Adiantamento foi para Aguardando NF.'
                    : 'Marcado como Valor não creditado.');
                fecharInformarCredito();
                buscarAdiantamentos();
            })
            .catch((err) => {
                toast.error('Erro: ' + (err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Erro desconhecido'));
            })
            .finally(() => setSalvandoCredito(false));
    };

    // D-0097: "Detalhes" abre a tela própria do adiantamento (antes era um modal só com o total por
    // fornecedor). Lá aparecem os itens solicitados, um a um, para o recibo do cliente.
    const abrirDetalhesAdiantamento = (parcela) => history.push(rotaDetalheAdiantamento(parcela.id));

    const baixarArquivoNF = async (arquivoId, nomeArquivo) => {
        if (!arquivoId) { toast.error('Arquivo não encontrado.'); return; }
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_URL + '/arquivo/download/' + arquivoId,
                { headers: { Authorization: 'Bearer ' + token }, responseType: 'blob' }
            );
            var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            var linkEl  = document.createElement('a');
            linkEl.href = blobUrl;
            linkEl.setAttribute('download', nomeArquivo || 'nota_fiscal');
            document.body.appendChild(linkEl);
            linkEl.click();
            linkEl.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            toast.error('Erro ao baixar o arquivo.');
        }
    };

    const handleFileUpload = (acaoApi, dadosUpload, callBack, onLoadingChange) => {
        // Este helper serve a VÁRIOS tipos de anexo (recibo, comprovante...).
        // A trava de PDF vale só para o recibo — comprovante segue aceitando imagem.
        const exigePdf = dadosUpload && dadosUpload.tipoArquivo === 'reciboadiantamento';
        const input = document.createElement('input');
        input.type = 'file';
        input.style.display = 'none';
        if (exigePdf) input.accept = ACEITE_RECIBO;
        input.onchange = (e) => {
            const file = e.target.files[0];
            if (!file) return;
            if (exigePdf) {
                const erroPdf = erroSeNaoForPdf(file);
                if (erroPdf) { toast.error(erroPdf); return; }
            }
            if (onLoadingChange) onLoadingChange(true);
            // Feedback IMEDIATO: o label "Enviando..." fica dentro do action-sheet,
            // que fecha ao clicar — sem isto o usuário não sabe que algo começou
            // (Rafael 2026-08-04). O toast de sucesso/erro já existia no fim.
            toast.info('Enviando ' + (file.name || 'arquivo') + '...', { autoClose: 2500 });
            const tokenUpload = localStorage.getItem('token');
            const formData = new FormData();
            formData.append('file', file);
            for (const [key, value] of Object.entries(dadosUpload)) {
                formData.append(key, value);
            }
            axios.post(
                process.env.REACT_APP_API_URL + '/' + acaoApi,
                formData,
                { headers: { 'content-type': 'multipart/form-data', 'Authorization': `Bearer ${tokenUpload}` } }
            )
                .then((response) => {
                    if (onLoadingChange) onLoadingChange(false);
                    if (callBack) callBack(response.data.data);
                    toast.success('Arquivo enviado com sucesso!');
                })
                .catch((error) => {
                    if (onLoadingChange) onLoadingChange(false);
                    toast.error('Erro ao enviar arquivo: ' + (error.response?.data?.error ?? "Erro desconhecido"));
                });
        };
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    };

    // D-0118: reenvia o aviso do recibo/comprovante aos responsáveis do evento (nada ao cliente).
    const reenviarAvisoDocumento = (row, tipo) => {
        api({ method: 'post', action: '/financeiroParcela/' + row.id + '/reenviarAvisoDocumento', token: token, data: { tipo: tipo } })
            .then(() => toast.success('Aviso reenviado aos responsáveis do evento.'))
            .catch((e) => toast.error((e.response && e.response.data && (e.response.data.error || e.response.data.mensagem)) || 'Erro ao reenviar o aviso.'));
    };

    const renderActionDropdown = (row) => {
        const actions = [];

        // Ações principais (antes eram botões na linha — consolidadas no menu)
        if (podeAprovarAdiantamento && !ehCreditado(row)) {
            actions.push({
                type: 'action',
                label: 'Informar Crédito',
                icon: <FaCheck size={14} />,
                description: 'Informar se o cliente creditou o adiantamento',
                onClick: () => abrirInformarCredito(row)
            });
        }
        // D-0118: com recibo, o Financeiro substitui e reenvia o aviso (antes a opção sumia).
        const podeDoc = podeGerenciarDocAdiantamento(perfil);
        const semPermissaoDoc = podeDoc ? {} : { disabled: true, ajuda: AVISO_SEM_PERMISSAO_DOC, descricaoAjuda: 'Só o Financeiro (ou admin/diretor)' };
        if (temRecibo(row)) {
            actions.push(Object.assign({
                type: 'upload',
                label: uploadingRecibo[row.id] ? 'Enviando recibo...' : 'Substituir recibo',
                icon: <FaUpload size={14} />,
                description: 'O novo vale para todas as parcelas do evento; o anterior fica no histórico', descricaoVisivel: true,
                acaoApi: 'financeiroParcelaArquivo/' + row.id,
                dados: { tipoArquivo: 'reciboadiantamento', modulo: 'financeiro', pasta: 'reciboadiantamento' },
                onLoadingChange: (v) => setUploadingRecibo(prev => ({ ...prev, [row.id]: v })),
                callBack: () => { buscarAdiantamentos(); }
            }, semPermissaoDoc));
            actions.push(Object.assign({
                type: 'action',
                label: 'Reenviar aviso do recibo',
                icon: <FaPaperPlane size={14} />,
                description: 'E-mail aos responsáveis do evento (não vai ao cliente)', descricaoVisivel: true,
                onClick: () => reenviarAvisoDocumento(row, 'reciboadiantamento')
            }, semPermissaoDoc));
        }
        if (!temRecibo(row)) {
            actions.push({
                type: 'upload',
                label: uploadingRecibo[row.id] ? 'Enviando recibo...' : 'Anexar recibo',
                icon: <FaUpload size={14} />,
                description: 'O item sai da lista quando tiver recibo + crédito confirmado',
                acaoApi: 'financeiroParcelaArquivo/' + row.id,
                dados: { tipoArquivo: 'reciboadiantamento', modulo: 'financeiro', pasta: 'reciboadiantamento' },
                // onLoadingChange existia mas ninguém passava — o estado
                // uploadingRecibo nunca era ligado (Rafael 2026-08-04).
                onLoadingChange: (v) => setUploadingRecibo(prev => ({ ...prev, [row.id]: v })),
                callBack: () => { buscarAdiantamentos(); }
            });
        }
        if (podeAprovarAdiantamento && !ehCreditado(row)) {
            actions.push({
                type: 'action',
                label: 'Prorrogar vencimento',
                icon: <FaCalendarAlt size={14} />,
                description: 'O cliente vai pagar em outra data — registra o motivo no histórico',
                onClick: () => setProrrogarModal({ parcela: row, data: '', motivo: '', salvando: false })
            });
        }
        actions.push({
            type: 'action',
            label: 'Detalhes',
            icon: <FaSearch size={14} />,
            description: 'Abre a tela do adiantamento com os itens solicitados',
            onClick: () => abrirDetalhesAdiantamento(row)
        });
        actions.push({
            type: 'action',
            label: 'Documentos',
            icon: <FaRegFileAlt size={14} />,
            description: 'Recibos e comprovantes: abrir, substituir e excluir', descricaoVisivel: true,
            onClick: () => setDocsModal(row)
        });

        actions.push({
            type: 'action',
            label: 'Alterar',
            icon: <FaPen size={14} />,
            disabled: true,
            ajuda: AJUDA_RENEGOCIACAO,
            onClick: () => {}
        });

        // "Pagar" saiu daqui (D-0097, Rafael 24/10): era um SweetAlert em HTML, sem
        // deduções nem valor pago.
        actions.push({ type: 'action', label: 'Estornar', icon: <FaThumbsDown size={14} />, disabled: true, ajuda: AJUDA_RENEGOCIACAO, onClick: () => {} });

        // Excluir = remove o pedido de adiantamento (soft-delete: fica registrado quem/quando)
        // e avisa o solicitante por e-mail. Bloqueado pelo backend se já recebido.
        const podeExcluir = ['admin', 'diretor', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'].includes(perfil);
        if (podeExcluir && (row.situacao === "1")) {
            actions.push({
                type: 'action',
                label: 'Excluir',
                icon: <ImCancelCircle size={14} />,
                onClick: () => {
                    setMotivoExcluir('');
                    setExcluirModal(row);
                }
            });
        }

        // D-0118: comprovante existente = substituir (só Financeiro) + reenviar o aviso.
        if (temComprovanteAdiantamento(row)) {
            actions.push(Object.assign({
                type: 'upload',
                label: 'Substituir comprovante',
                icon: <FaUpload size={16} />,
                description: 'O anterior fica no histórico', descricaoVisivel: true,
                acaoApi: "financeiroParcelaArquivo/" + row.id,
                dados: { tipoArquivo: "comprovantepagamento", modulo: "financeiro", pasta: "comprovantepagamento" },
                callBack: () => { buscarAdiantamentos(); }
            }, semPermissaoDoc));
            actions.push(Object.assign({
                type: 'action',
                label: 'Reenviar aviso do comprovante',
                icon: <FaPaperPlane size={14} />,
                description: 'E-mail aos responsáveis do evento (não vai ao cliente nem ao fornecedor)', descricaoVisivel: true,
                onClick: () => reenviarAvisoDocumento(row, 'comprovantepagamento')
            }, semPermissaoDoc));
        } else {
            actions.push({
                type: 'upload',
                label: 'Anexar comprovante',
                icon: <FaUpload size={16} />,
                acaoApi: "financeiroParcelaArquivo/" + row.id,
                dados: { tipoArquivo: "comprovantepagamento", modulo: "financeiro", pasta: "comprovantepagamento" },
                callBack: () => { buscarAdiantamentos(); }
            });
        }

        if (actions.length === 0) return null;

        return (
            <button
                className="fin-pp__rowbtn"
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setActionsModalData({ parcela: row, actions: actions });
                    setShowActionsModal(true);
                }}
            >
                <FaEllipsisV size={14} />
            </button>
        );
    };

    useEffect(() => {
        buscarAdiantamentos();
        buscarCaixas();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Dados derivados ──────────────────────────────────────────────────────────
    // O item só SAI da lista quando tiver AMBOS: recibo anexado E crédito confirmado
    // (status_pagamento='creditado'). Só recibo → "Aguardando crédito"; só crédito →
    // "Aguardando recibo". Ir p/ Custo Previsto (dataAprovacaoDiretor) independe disso.
    // Removidos/reprovados não aparecem.
    const lista = adiantamentos.filter(a => !a.removido_em && !a.dataReprovacaoDiretor && !(temRecibo(a) && ehCreditado(a)));
    // Lembrete na tela (item 13, opção A — sem agendador): adiantamento sem crédito
    // confirmado com vencimento hoje ou já passado. É o "lembrar tal dia" da reunião.
    const hojeIso = moment().format('YYYY-MM-DD');
    const venceuSemCredito = (a) => !ehCreditado(a) && !!a.vencimento && String(a.vencimento).slice(0, 10) <= hojeIso;
    const vencidosSemCredito = lista.filter(venceuSemCredito);
    const buscaLower = busca.toLowerCase().trim();
    const porEvento = lista.reduce(function(acc, p) {
        const evId   = (p.titulo && p.titulo.evento && p.titulo.evento.id) || (p.evento && p.evento.id) || '__sem_evento__';
        const evNome = (p.titulo && p.titulo.evento && p.titulo.evento.nome) || (p.evento && p.evento.nome) || '(sem evento)';
        // Backend já eager-carrega titulo.evento.cliente (criarBuscaParcelasBase) —
        // não precisou mudar nada na API, só ler o campo que já vinha e nunca era usado.
        const cli      = (p.titulo && p.titulo.evento && p.titulo.evento.cliente) || (p.evento && p.evento.cliente) || null;
        const cliId    = cli ? cli.id : '__sem_cliente__';
        const cliNome  = cli ? (cli.nomefantasia || cli.nome) : 'Sem cliente';
        if (soVencidosSemCredito && !venceuSemCredito(p)) return acc;
        if (!acc[evId]) acc[evId] = { evId, evNome, cliId, cliNome, parcelas: [] };
        acc[evId].parcelas.push(p);
        return acc;
    }, {});
    // Opções do select — só os clientes que de fato aparecem na lista atual.
    const clientesDisponiveis = Array.from(
        new Map(Object.values(porEvento).map(function(g) { return [g.cliId, g.cliNome]; })).entries()
    ).sort(function(a, b) { return a[1].localeCompare(b[1]); });
    const gruposVisiveis = Object.values(porEvento).filter(function(g) {
        if (filtroCliente && String(g.cliId) !== String(filtroCliente)) return false;
        if (!buscaLower) return true;
        return g.evNome.toLowerCase().includes(buscaLower) ||
            g.cliNome.toLowerCase().includes(buscaLower) ||
            g.parcelas.some(function(p) { return (p.descricao || '').toLowerCase().includes(buscaLower); });
    });
    const todosExpandidos = gruposVisiveis.length > 0 && gruposVisiveis.every(function(g) { return eventosAdiantAbertos[g.evId] !== false && (eventosAdiantAbertos[g.evId] === true || g.parcelas.some(function(p) { return p.situacao === '1' || p.situacao === 1; })); });
    const toggleTodos = function() {
        var prox = !todosExpandidos;
        var novo = {};
        gruposVisiveis.forEach(function(g) { novo[g.evId] = prox; });
        setEventosAdiantAbertos(function(prev) { return Object.assign({}, prev, novo); });
    };

    return (
        <div className="fin-pp">
            {/* ── Filtro ──────────────────────────────────────────────────────── */}
            <div className="fin-pp__card" style={{ padding: '14px 16px', marginBottom: 14 }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                    <div className="fin-pp__search-field" style={{ flex: '1 1 240px' }}>
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            type="text"
                            className="fin-pp__input"
                            placeholder="Buscar evento, cliente ou descrição…"
                            value={busca}
                            onChange={function(e) { setBusca(e.target.value); }}
                        />
                    </div>
                    <select className="fin-pp__select" value={filtroCliente} onChange={function(e) { setFiltroCliente(e.target.value); }}>
                        <option value="">Todos os clientes</option>
                        {clientesDisponiveis.map(function(c) { return <option key={c[0]} value={c[0]}>{c[1]}</option>; })}
                    </select>
                    <button
                        className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall"
                        onClick={buscarAdiantamentos}
                        disabled={loadingAdiantamentos}
                    >
                        <FaSync size={13} className={loadingAdiantamentos ? 'fa-spin' : ''} />
                        {loadingAdiantamentos ? 'Carregando…' : 'Atualizar'}
                    </button>
                    <button
                        className="fin-pp__btn fin-pp__btn--tall"
                        onClick={toggleTodos}
                        disabled={gruposVisiveis.length === 0}
                    >
                        {todosExpandidos ? 'Colapsar todos' : 'Expandir todos'}
                    </button>
                </div>
            </div>

            {vencidosSemCredito.length > 0 && (
                <div className="fin-pp__banner is-warn" style={{ alignItems: 'center' }}>
                    <FaClock className="fin-pp__banner-ic" size={15} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <strong>{vencidosSemCredito.length} adiantamento{vencidosSemCredito.length !== 1 ? 's' : ''} sem crédito com vencimento hoje ou já passado</strong>
                        {' '}· R$ {moeda(vencidosSemCredito.reduce((s, a) => s + (parseFloat(a.valor) || 0), 0))}.
                        {' '}Confirme se caiu (Informar Crédito) ou prorrogue o vencimento.
                    </div>
                    <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setSoVencidosSemCredito(v => !v)}>
                        {soVencidosSemCredito ? 'Mostrar todos' : 'Ver só esses'}
                    </button>
                </div>
            )}

            {/* ── Grupos por evento ─────────────────────────────────────────── */}
            {loadingAdiantamentos ? (
                <div className="fin-pp__empty">Carregando adiantamentos…</div>
            ) : lista.length === 0 ? (
                <div className="fin-pp__empty">Nenhum adiantamento aguardando decisão.</div>
            ) : gruposVisiveis.length === 0 ? (
                <div className="fin-pp__empty">Nenhum resultado para "{busca}".</div>
            ) : (
                <div className="fin-pp__groups">
                    {gruposVisiveis.map(function(grupo) {
                        const totalGrupo = grupo.parcelas.reduce((s, p) => s + parseFloat(p.valor || 0), 0);
                        const emAberto   = grupo.parcelas.filter(p => p.situacao === '1' || p.situacao === 1).length;
                        const estaAberto = eventosAdiantAbertos[grupo.evId] !== undefined
                            ? eventosAdiantAbertos[grupo.evId]
                            : emAberto > 0;

                        var pComRecibo = grupo.parcelas.find(function(p) {
                            var r = p.arquivoreciboadiantamento;
                            return !!(r && (typeof r === 'object' ? r.id : r));
                        });
                        var primeiraParcelaId = grupo.parcelas[0] && grupo.parcelas[0].id;

                        return (
                            <div key={grupo.evId} className="fin-pp__grp">
                                {/* ── Cabeçalho acordeão ── */}
                                <div
                                    className="fin-pp__grp-head"
                                    onClick={() => toggleEventoAdianto(grupo.evId, estaAberto)}
                                >
                                    <span className="fin-pp__grp-caret">
                                        {estaAberto ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
                                    </span>
                                    <span className="fin-pp__grp-ic"><FaCalendarAlt size={15} /></span>
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        <div className="fin-pp__grp-name">
                                            {grupo.evNome}
                                            <span style={{ fontWeight: 400, fontSize: '0.8rem', color: 'var(--fin-mt)', marginLeft: 6 }}>
                                                · {grupo.parcelas.length} parcela{grupo.parcelas.length !== 1 ? 's' : ''}
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2, flexWrap: 'wrap' }}>
                                            {emAberto > 0 && (
                                                <span className="fin-pp__pill is-warn" style={{ fontSize: '0.72rem' }}>{emAberto} em aberto</span>
                                            )}
                                            {pComRecibo ? (function() {
                                                var r = pComRecibo.arquivoreciboadiantamento;
                                                var rid  = typeof r === 'object' ? r.id  : r;
                                                var rnom = (r && typeof r === 'object' && r.nome) ? r.nome : 'recibo_adiantamento';
                                                return (
                                                    <button
                                                        type="button"
                                                        className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--ok"
                                                        style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                                        title="Baixar recibo de adiantamento"
                                                        onClick={function(e) { e.stopPropagation(); baixarArquivoNF(rid, rnom); }}
                                                    >
                                                        Recibo
                                                    </button>
                                                );
                                            })() : (
                                                <button
                                                    type="button"
                                                    className="fin-pp__btn fin-pp__btn--sm"
                                                    disabled={!!uploadingRecibo[primeiraParcelaId]}
                                                    style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                                    title={uploadingRecibo[primeiraParcelaId] ? 'Enviando recibo...' : 'Upload do recibo de adiantamento'}
                                                    onClick={function(e) {
                                                        e.stopPropagation();
                                                        if (!primeiraParcelaId || uploadingRecibo[primeiraParcelaId]) return;
                                                        handleFileUpload(
                                                            'financeiroParcelaArquivo/' + primeiraParcelaId,
                                                            { tipoArquivo: 'reciboadiantamento', modulo: 'financeiro', pasta: 'reciboadiantamento' },
                                                            function() { buscarAdiantamentos(); },
                                                            function(loading) {
                                                                setUploadingRecibo(function(prev) {
                                                                    return Object.assign({}, prev, { [primeiraParcelaId]: loading });
                                                                });
                                                            }
                                                        );
                                                    }}
                                                >
                                                    {uploadingRecibo[primeiraParcelaId] ? 'Enviando...' : 'Recibo'}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                        <div className="fin-pp__minicard-label">Total</div>
                                        <div className="fin-pp__minicard-value is-info">R$ {moeda(totalGrupo)}</div>
                                    </div>
                                </div>

                                {/* ── D-0118: o que o Financeiro precisa para emitir o recibo (é do evento,
                                     igual para todas as parcelas do grupo) ── */}
                                {estaAberto && (function() {
                                    var comDados = grupo.parcelas.find(function(p) { return !!p.dados_recibo; });
                                    var dr = comDados ? comDados.dados_recibo : null;
                                    if (!dr) return null;
                                    var dest = destinatarioRecibo(dr);
                                    var po = posDoEvento(dr);
                                    var rotulo = { color: 'var(--fin-mt)', marginRight: 6 };
                                    return (
                                        <div data-dados-recibo style={{ borderTop: '1px solid var(--fin-bd)', background: 'var(--fin-acw)', padding: '10px 14px', display: 'flex', gap: '8px 22px', flexWrap: 'wrap', alignItems: 'center', fontSize: '0.82rem' }}>
                                            <span><span style={rotulo}>Data do evento</span><strong>{periodoEvento(dr)}</strong></span>
                                            <span>
                                                <span style={rotulo}>Recibo para</span>
                                                {dest ? (
                                                    <>
                                                        <strong>{dest.nome}</strong>
                                                        {dest.cargo ? <span className="fin-pp__cell-muted"> ({dest.cargo})</span> : null}
                                                        {' · '}
                                                        {dest.email
                                                            ? <a href={'mailto:' + dest.email} onClick={function(e) { e.stopPropagation(); }}>{dest.email}</a>
                                                            : <span className="fin-pp__pill is-warn">sem e-mail cadastrado</span>}
                                                    </>
                                                ) : (
                                                    <span className="fin-pp__pill is-warn" title="Cadastre o responsável do cliente no evento">Responsável do cliente não cadastrado no evento</span>
                                                )}
                                            </span>
                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                                <span style={rotulo}>P.O.</span>
                                                {po.tipo === 'nao_aplica' && <span className="fin-pp__cell-muted">Não se aplica</span>}
                                                {po.tipo === 'nenhuma' && <span className="fin-pp__pill is-warn">Nenhuma P.O. no evento</span>}
                                                {po.pos.map(function(item, i) {
                                                    return (
                                                        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                                            <span className={'fin-pp__minitag ' + (item.aprovada ? 'is-ok' : 'is-info')} title={item.aprovada ? 'P.O. aprovada' : 'P.O. ainda não aprovada'}>
                                                                {item.numero || 'sem número'}{item.aprovada ? ' · aprovada' : ''}
                                                            </span>
                                                            {item.arquivo_id ? (
                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" style={{ fontSize: '0.72rem', padding: '2px 8px' }}
                                                                    title="Abrir o arquivo da P.O."
                                                                    onClick={function(e) { e.stopPropagation(); baixarArquivoNF(item.arquivo_id, item.arquivo_nome || ('PO_' + (item.numero || ''))); }}>
                                                                    Abrir
                                                                </button>
                                                            ) : (
                                                                <span className="fin-pp__cell-muted" style={{ fontSize: '0.75rem' }}>sem arquivo</span>
                                                            )}
                                                        </span>
                                                    );
                                                })}
                                            </span>
                                        </div>
                                    );
                                })()}

                                {/* ── Tabela ── */}
                                {estaAberto && (
                                    <div style={{ borderTop: '1px solid var(--fin-bd)' }}>
                                        <div className="fin-pp__tblwrap">
                                            <table className="fin-pp__tbl" style={{ minWidth: 900, tableLayout: 'auto' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Situação</th>
                                                        <th>Status</th>
                                                        <th>Descrição</th>
                                                        <th>Conta</th>
                                                        <th>Vencimento</th>
                                                        <th style={{ textAlign: 'right' }}>Valor</th>
                                                        <th>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {grupo.parcelas.map(function(p) {
                                                        const isAberto  = p.situacao === '1' || p.situacao === 1;
                                                        const venc      = p.vencimento ? moment(p.vencimento) : null;
                                                        const vencido   = venc && venc.isBefore(moment(), 'day');
                                                        const venc7dias = venc && !vencido && venc.diff(moment(), 'days') <= 7;
                                                        return (
                                                            <tr key={p.id} style={{ cursor: 'pointer' }} title="Ver detalhes"
                                                                onClick={(e) => { if (!cliqueEmControle(e.target)) abrirDetalhesAdiantamento(p); }}>
                                                                <td>
                                                                    {isAberto
                                                                        ? <span className="fin-pp__pill is-warn">Aberto</span>
                                                                        : <span className="fin-pp__pill is-ok">Pago</span>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {p.dataAprovacaoDiretor ? (
                                                                        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                                                            {/* A cor NAO pode ser verde quando o credito ainda nao caiu.
                                                                                `dataAprovacaoDiretor` e setado tambem ao ANEXAR O RECIBO
                                                                                (FinanceiroParcelaController::uploadArquivo), entao o item
                                                                                exibia "✅" so por ter recibo — ao lado de "Aguardando
                                                                                credito", que dizia o contrario (Rafael 2026-08-06). */}
                                                                            {ehCreditado(p) ? (
                                                                                <span className="fin-pp__pill is-ok" title="Cliente pagou: crédito confirmado pelo Financeiro. Já está em Contas Pendentes (Aguardando NF).">
                                                                                    ✅ Crédito confirmado
                                                                                </span>
                                                                            ) : (
                                                                                <span className="fin-pp__pill is-info" title="Liberado para Contas Pendentes (Aguardando NF) porque o recibo foi anexado. O dinheiro ainda NÃO foi confirmado — use Informar Crédito quando cair.">
                                                                                    📤 Em Contas Pendentes
                                                                                </span>
                                                                            )}
                                                                            {!temRecibo(p) && (
                                                                                <span className="fin-pp__pill is-warn" title="Anexe o recibo do adiantamento — o item só sai desta lista com recibo + crédito confirmado">
                                                                                    📄 Aguardando recibo
                                                                                </span>
                                                                            )}
                                                                            {p.status_pagamento === 'nao_creditado' ? (
                                                                                <span
                                                                                    className="fin-pp__pill is-danger"
                                                                                    title={p.status_pagamento_obs ? 'Obs: ' + p.status_pagamento_obs : 'Valor não caiu — renegociar com o fornecedor'}
                                                                                >
                                                                                    <FaTimes size={10} style={{ marginRight: 3 }} />Não creditado
                                                                                </span>
                                                                            ) : !ehCreditado(p) && (
                                                                                <span className="fin-pp__pill is-warn" title="Crédito ainda não confirmado pelo Financeiro — use Informar Crédito quando o valor cair">
                                                                                    💰 Aguardando crédito
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    ) : p.status_pagamento === 'nao_creditado' ? (
                                                                        <span
                                                                            className="fin-pp__pill is-danger"
                                                                            title={p.status_pagamento_obs ? 'Obs: ' + p.status_pagamento_obs : 'Valor não caiu — renegociar com o fornecedor'}
                                                                        >
                                                                            <FaTimes size={10} style={{ marginRight: 3 }} />Não creditado
                                                                        </span>
                                                                    ) : (
                                                                        <span className="fin-pp__cell-muted" style={{ fontSize: '0.8rem' }}>Aguardando</span>
                                                                    )}
                                                                </td>
                                                                <td className="fin-pp__cell-muted">
                                                                    {p.descricao || '—'}
                                                                    {/* D-0120: "Adiantamento já feito" — cliente já pagou; recibo e baixa como sempre. */}
                                                                    <AdiantamentoClientePagou adiantamento={p} perfil={perfil} />
                                                                </td>
                                                                <td className="fin-pp__cell-muted" style={{ fontSize: '0.8rem' }}>
                                                                    {p.caixa ? `${p.caixa.codigo} - ${p.caixa.nome}` : '—'}
                                                                </td>
                                                                <td style={{ color: vencido ? 'var(--fin-dg)' : venc7dias ? 'var(--fin-wn)' : 'inherit', fontWeight: vencido || venc7dias ? 600 : 400 }}>
                                                                    {venc ? venc.format('DD/MM/YYYY') : '—'}
                                                                    {p.prorrogacoes > 0 && (
                                                                        <div>
                                                                            <span className="fin-pp__minitag is-info" title={'Vencimento prorrogado pelo Financeiro' + (p.prorrogacoes > 1 ? ' ' + p.prorrogacoes + ' vezes' : '') + ' — motivo no Detalhes'}>
                                                                                🔁 Prorrogado{p.prorrogacoes > 1 ? ' ' + p.prorrogacoes + 'x' : ''}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                    {p.voltas > 0 && (
                                                                        <div>
                                                                            <span className="fin-pp__minitag is-warn" title={'Voltou ao Eventos ' + p.voltas + (p.voltas > 1 ? ' vezes' : ' vez') + ' (reprovado ou não creditado) — detalhes no histórico'}>
                                                                                ↩ Voltou {p.voltas}x
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="fin-pp__cell-strong" style={{ textAlign: 'right' }}>
                                                                    R$ {moeda(p.valor)}
                                                                </td>
                                                                <td>
                                                                    {renderActionDropdown(p)}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            {/* ── Action Sheet ─────────────────────────────────────────────── */}
            {showActionsModal && (
                <div className="fin-pp fin-pp__sheet-backdrop" onClick={() => setShowActionsModal(false)}>
                    <div className="fin-pp__sheet" onClick={(e) => e.stopPropagation()}>
                        <div className="fin-pp__sheet-head">
                            <span className="fin-pp__sheet-head-ic"><FaEllipsisV size={17} /></span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <h3 className="fin-pp__sheet-title">Ações</h3>
                                <p className="fin-pp__sheet-sub">{actionsModalData.parcela?.descricao || 'Adiantamento'}</p>
                            </div>
                            <button type="button" className="fin-pp__sheet-close" onClick={() => setShowActionsModal(false)}>
                                <FaTimes size={16} />
                            </button>
                        </div>
                        <div className="fin-pp__sheet-body">
                            {actionsModalData.actions.map(function(action, index) {
                                if (action.type === 'link') {
                                    return (
                                        <Link
                                            key={index}
                                            className="fin-pp__sheet-item"
                                            to={action.to}
                                            onClick={() => setShowActionsModal(false)}
                                        >
                                            <span className="fin-pp__sheet-item-ic">{action.icon}</span>
                                            <span className="fin-pp__sheet-item-txt">
                                                <span className="fin-pp__sheet-item-label">{action.label}</span>
                                            </span>
                                        </Link>
                                    );
                                }
                                if (action.type === 'upload') {
                                    return (
                                        <button
                                            key={index}
                                            type="button"
                                            className={'fin-pp__sheet-item' + (action.disabled ? ' is-disabled' : '')}
                                            title={action.ajuda || undefined}
                                            onClick={(e) => {
                                                if (action.disabled) return;
                                                e.stopPropagation();
                                                handleFileUpload(action.acaoApi, action.dados, action.callBack, action.onLoadingChange);
                                                setShowActionsModal(false);
                                            }}
                                        >
                                            <span className="fin-pp__sheet-item-ic">{action.icon}</span>
                                            <span className="fin-pp__sheet-item-txt">
                                                <span className="fin-pp__sheet-item-label">{action.label}{action.ajuda && <FinAjuda texto={action.ajuda} />}</span>
                                                {(action.descricaoAjuda || (action.descricaoVisivel && action.description)) && <span className="fin-pp__sheet-item-desc">{action.descricaoAjuda || action.description}</span>}
                                            </span>
                                            {action.disabled && <span className="fin-pp__sheet-badge">Indisponível</span>}
                                        </button>
                                    );
                                }
                                return (
                                    <button
                                        key={index}
                                        type="button"
                                        className={'fin-pp__sheet-item' + (action.disabled ? ' is-disabled' : '')}
                                        title={action.ajuda || undefined}
                                        onClick={(e) => {
                                            if (action.disabled) return;
                                            e.stopPropagation();
                                            action.onClick();
                                            setShowActionsModal(false);
                                        }}
                                    >
                                        <span className="fin-pp__sheet-item-ic">{action.icon}</span>
                                        <span className="fin-pp__sheet-item-txt">
                                            <span className="fin-pp__sheet-item-label">{action.label}{action.ajuda && <FinAjuda texto={action.ajuda} />}</span>
                                            {action.ajuda
                                                ? <span className="fin-pp__sheet-item-desc">{action.descricaoAjuda || 'Renegociação: equipe do evento, em Orçamento › Solicitar Adiantamento › Adiantamentos'}</span>
                                                : (action.descricaoVisivel && action.description && <span className="fin-pp__sheet-item-desc">{action.description}</span>)}
                                        </span>
                                        {action.disabled && <span className="fin-pp__sheet-badge">Indisponível</span>}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {docsModal && (
                <DocumentosParcelaModal
                    parcela={docsModal}
                    subtitulo={docsModal.descricao}
                    fechar={() => setDocsModal(null)}
                    podeGerenciar={podeGerenciarDocAdiantamento(perfil)}
                    avisoSemPermissao={AVISO_SEM_PERMISSAO_DOC}
                    onAlterado={() => buscarAdiantamentos()}
                />
            )}

            {/* ── Modal: Prorrogar vencimento (item 13) ── */}
            {prorrogarModal && (function() {
                const pm = prorrogarModal;
                const fechar = function() { if (!pm.salvando) setProrrogarModal(null); };
                const dataIso = pm.data && moment(pm.data, 'DD/MM/YYYY', true).isValid() ? moment(pm.data, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const amanha = moment().add(1, 'day').format('YYYY-MM-DD');
                const erroData = pm.data && !dataIso ? 'Data inválida.' : (dataIso && dataIso < amanha ? 'A nova data precisa ser a partir de amanhã.' : null);
                const podeSalvar = !!dataIso && !erroData && pm.motivo.trim() !== '' && !pm.salvando;
                const salvar = function() {
                    setProrrogarModal(Object.assign({}, pm, { salvando: true }));
                    api({ method: 'put', action: '/financeiroParcela/' + pm.parcela.id + '/prorrogarAdiantamento', token: token,
                        data: { vencimento: dataIso, motivo: pm.motivo.trim() } })
                        .then(function(r) {
                            toast.success((r.data && r.data.mensagem) || 'Vencimento prorrogado.');
                            setProrrogarModal(null);
                            buscarAdiantamentos();
                        })
                        .catch(function(e) {
                            toast.error((e.response && e.response.data && e.response.data.mensagem) || 'Erro ao prorrogar o vencimento.');
                            setProrrogarModal(function(prev) { return prev ? Object.assign({}, prev, { salvando: false }) : prev; });
                        });
                };
                return (
                    <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}
                        onClick={function(e) { if (e.target === e.currentTarget) fechar(); }}>
                        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
                            <div className="modal-content fin-pp__modal fin-pp__modal--flow">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaCalendarAlt size={16} /></span>
                                    <h3 className="fin-pp__modal-title">Prorrogar vencimento
                                        <span className="fin-pp__modal-sub">{pm.parcela.descricao || 'Adiantamento'}</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={fechar}><FaTimes size={16} /></button>
                                </div>
                                <div className="modal-body" style={{ minHeight: 330 }}>
                                    <p className="fin-pp__cell-muted" style={{ marginTop: 0 }}>
                                        Vencimento atual: <strong>{pm.parcela.vencimento ? moment(pm.parcela.vencimento).format('DD/MM/YYYY') : '—'}</strong>
                                        {' '}· R$ {moeda(pm.parcela.valor)}. O motivo fica no histórico do adiantamento.
                                    </p>
                                    <div className="fin-pp__filters">
                                        <Data label="Nova data de vencimento" value={pm.data}
                                            onChange={function(d) {
                                                // O datepicker também chama onChangeRaw no clique do dia, com
                                                // event.target.value indefinido — ignorar para não apagar a data.
                                                if (d === undefined || d === null) return;
                                                setProrrogarModal(function(prev) { return prev ? Object.assign({}, prev, { data: d }) : prev; });
                                            }} />
                                        <FinField label="Motivo" required full>
                                            <FinTextarea rows={3} value={pm.motivo} placeholder="Ex.: cliente informou que paga dia 15"
                                                onChange={function(e) { var v = e.target.value; setProrrogarModal(function(prev) { return prev ? Object.assign({}, prev, { motivo: v }) : prev; }); }} />
                                        </FinField>
                                    </div>
                                    {erroData && <div role="alert" style={{ color: 'var(--fin-dg)', fontSize: 12.5, marginTop: 8 }}>{erroData}</div>}
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={fechar} disabled={pm.salvando}>Cancelar</button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={salvar} disabled={!podeSalvar}>
                                        {pm.salvando ? 'Salvando…' : 'Prorrogar'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ── Modal: Informar Crédito (Creditado / Não creditado) ── */}
            {modalCredito && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 480 }}>
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaCheck size={16} /></span>
                                <h3 className="fin-pp__modal-title">Informar Crédito do Adiantamento
                                    <span className="fin-pp__modal-sub">{modalCredito.descricao || 'Adiantamento'}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={fecharInformarCredito}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">Os responsáveis do evento e o Financeiro receberão um e-mail com o status.</p>
                                <div className="d-flex gap-2 mb-3">
                                    <button type="button" onClick={() => setModalCreditoSel('creditado')}
                                        style={{ flex: 1, padding: '12px 8px', borderRadius: 8, cursor: 'pointer',
                                            border: modalCreditoSel === 'creditado' ? '2px solid #198754' : '2px solid #dee2e6',
                                            background: modalCreditoSel === 'creditado' ? '#d1e7dd' : '#fff',
                                            color: modalCreditoSel === 'creditado' ? '#0f5132' : '#6c757d',
                                            fontWeight: modalCreditoSel === 'creditado' ? 700 : 400, textAlign: 'center', fontSize: '0.88rem' }}>
                                        ✅ Creditado<br />
                                        <small style={{ fontWeight: 400, fontSize: '0.72rem' }}>Cliente pagou → Aguardando NF</small>
                                    </button>
                                    <button type="button" onClick={() => setModalCreditoSel('nao_creditado')}
                                        style={{ flex: 1, padding: '12px 8px', borderRadius: 8, cursor: 'pointer',
                                            border: modalCreditoSel === 'nao_creditado' ? '2px solid #dc3545' : '2px solid #dee2e6',
                                            background: modalCreditoSel === 'nao_creditado' ? '#f8d7da' : '#fff',
                                            color: modalCreditoSel === 'nao_creditado' ? '#842029' : '#6c757d',
                                            fontWeight: modalCreditoSel === 'nao_creditado' ? 700 : 400, textAlign: 'center', fontSize: '0.88rem' }}>
                                        ❌ Não Creditado<br />
                                        <small style={{ fontWeight: 400, fontSize: '0.72rem' }}>Valor não caiu → renegociar</small>
                                    </button>
                                </div>
                                {modalCreditoSel === 'creditado' && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label small fw-bold">
                                                Onde o valor caiu <span style={{ color: 'var(--fin-dg)' }}>*</span>
                                                <span className="text-muted fw-normal"> (conta / banco / cartão)</span>
                                            </label>
                                            <select className="form-select form-select-sm"
                                                value={(caixas || []).some(c => String(c.id) === String(modalCreditoCaixa)) ? modalCreditoCaixa : ''}
                                                onChange={e => setModalCreditoCaixa(e.target.value)}>
                                                <option value="">{carregandoCaixas && (caixas || []).length === 0 ? 'Carregando contas...' : 'Selecione...'}</option>
                                                {(caixas || []).map(c => (
                                                    <option key={c.id} value={c.id}>
                                                        {c.nome}{parseFloat(c.cartaolimite) > 0 ? ' (cartão)' : ''}
                                                    </option>
                                                ))}
                                            </select>
                                            {!carregandoCaixas && (caixas || []).length === 0 && (
                                                <div className="small text-muted mt-1">
                                                    Nenhum caixa cadastrado — cadastre em Financeiro → Caixas.
                                                </div>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label small fw-bold">Data em que o valor foi creditado <span className="text-muted fw-normal">(opcional — padrão: hoje)</span></label>
                                            <input type="date" className="form-control form-control-sm"
                                                value={modalCreditoData} onChange={e => setModalCreditoData(e.target.value)} />
                                        </div>
                                    </>
                                )}
                                <div className="mb-1">
                                    <label className="form-label small fw-bold">Observação <span className="text-muted fw-normal">(opcional — aparece no e-mail)</span></label>
                                    <textarea className="form-control form-control-sm" rows={3}
                                        placeholder={modalCreditoSel === 'nao_creditado' ? 'Ex: cliente informou nova data...' : 'Ex: pagamento recebido via TED em...'}
                                        value={modalCreditoObs} onChange={e => setModalCreditoObs(e.target.value)} />
                                </div>
                                {modalCreditoSel === 'creditado' && !temRecibo(modalCredito) && (
                                    <div className="mt-3 p-2 rounded small" style={{ background: '#fff3cd', border: '1px solid #ffc107', color: '#664d03' }}>
                                        ⚠️ Este adiantamento ainda NÃO tem recibo anexado. Você pode prosseguir — o item só sai da lista de Adiantamento quando tiver recibo anexado + crédito confirmado; até lá ficará como "Aguardando recibo".
                                    </div>
                                )}
                                {modalCreditoSel === 'nao_creditado' && (
                                    <div className="mt-3 p-2 rounded small" style={{ background: '#fff3cd', border: '1px solid #ffc107', color: '#664d03' }}>
                                        ⚠️ O responsável poderá renegociar a data com o fornecedor na tela do evento.
                                    </div>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={fecharInformarCredito}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm"
                                    disabled={!modalCreditoSel || salvandoCredito}
                                    style={{ background: modalCreditoSel === 'creditado' ? 'var(--fin-ok)' : modalCreditoSel === 'nao_creditado' ? 'var(--fin-dg)' : 'var(--fin-mt)', color: '#fff', border: 0 }}
                                    onClick={salvarInformarCredito}>
                                    {salvandoCredito ? 'Salvando...' : 'Confirmar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Modal: Excluir pedido de adiantamento (padrão fin-pp) ── */}
            {excluirModal && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={(e) => { if (e.target === e.currentTarget && !excluindoAdt) setExcluirModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 480 }}>
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><ImCancelCircle size={17} /></span>
                                <h3 className="fin-pp__modal-title">Excluir pedido de adiantamento
                                    <span className="fin-pp__modal-sub">{excluirModal.descricao} · {moeda(excluirModal.valor)}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => setExcluirModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p className="small text-muted mb-3">
                                    O pedido será <strong>removido</strong> da lista (fica registrado no histórico: quem removeu e quando)
                                    e o <strong>solicitante será avisado por e-mail</strong>.
                                </p>
                                <div className="fin-pp__field" style={{ width: '100%' }}>
                                    <label className="fin-pp__label">Motivo (opcional)</label>
                                    <textarea className="fin-pp__input" rows={3}
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        placeholder="Ex: pedido duplicado, valor incorreto..."
                                        value={motivoExcluir}
                                        onChange={e => setMotivoExcluir(e.target.value)} />
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setExcluirModal(null)} disabled={excluindoAdt}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" disabled={excluindoAdt}
                                    onClick={() => {
                                        if (excluindoAdt || !excluirModal) return;
                                        setExcluindoAdt(true);
                                        api({
                                            method: 'put',
                                            action: '/financeiroParcela/' + excluirModal.id + '/excluirAdiantamento',
                                            token: token,
                                            data: { motivo: motivoExcluir }
                                        })
                                            .then(function () {
                                                setExcluirModal(null);
                                                setMotivoExcluir('');
                                                buscarAdiantamentos();
                                                toast.success('Pedido de adiantamento excluído. Solicitante avisado.');
                                            })
                                            .catch(function (err) {
                                                toast.error('Erro ao excluir: ' + (err.response && err.response.data && err.response.data.error ? err.response.data.error : 'tente novamente'));
                                            })
                                            .finally(function () { setExcluindoAdt(false); });
                                    }}>
                                    <ImCancelCircle size={14} /> {excluindoAdt ? 'Excluindo...' : 'Excluir pedido'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
